import { useTranslation } from 'react-i18next'
import { AuthContext } from 'src/contexts/authContext'
import {useContext} from "react";

export const tenderOverviewColumns = () => {
  const authContext = useContext(AuthContext)
  const { t } = useTranslation()

  const columns = [
    {
      key: 'hgcSalesforceProject',
      label: t('TenderName'),
    },
    {
      key: 'departmentName',
      label: t('DepartmentName'),
    },
    {
      key: 'uploaderUserName',
      label: !authContext.userInfo || !authContext.systemSettings ? t('User').replace("HGC", "") : (!authContext.systemSettings.replaceWordingPerTenderOffice || authContext.role === 'devis_admin' ? t('User') : t('User').replace("HGC", authContext.userInfo.departmentsNames[0])),
    },
    {
      key: 'offerDueDate',
      label: !authContext.userInfo || !authContext.systemSettings ? t('TenderView.DueDateHGCOffers').replace("HGC", "") : (!authContext.systemSettings.replaceWordingPerTenderOffice || authContext.role === 'devis_admin' ? t('TenderView.DueDateHGCOffers') : t('TenderView.DueDateHGCOffers').replace("HGC", authContext.userInfo.departmentsNames[0])),
    },
    {
      key: 'supplierDueDate',
      label: t('TenderView.DueDateSupplierOffers'),
    },
    {
      key: 'uploadedAt',
      label: t('UploadDate'),
      _style: { width: '10%' },
    },
    {
      key: 'status',
      label: t('Status'),
      _style: { width: '15%' },
    },
  ]
  return columns
}
